namespace RioERP.Carts {
    export interface CounterCartRow {
        Id?: number;
        Name?: string;
        FranchiseeId?: number;
        CustomerId?: number;
        CustomerName?: string;
        CustomerEmail1?: string;
        CustomerEmail2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        BillingAddress1?: string;
        BillingAddress2?: string;
        BillingCity?: string;
        BillingStateId?: number;
        BillingPincode?: number;
        ShippingAddress1?: string;
        ShippingAddress2?: string;
        ShippingCity?: string;
        ShippingStateId?: number;
        ShippingPincode?: number;
        EInvoiceTo?: number;
        EPaymentStatus?: Web.Enums.PaymentStatus;
        EPaymentType?: RioErp.Web.Enums.PaymentType;
        InvoiceCompanyId?: number;
        DiscountCoupon?: string;
        DiscountAmount?: number;
        SourceOrderNumber?: string;
        GrossAmount?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        EFranchiseeDiscountType?: number;
        EFranchiseeDiscount?: number;
        FranchiseeDiscountValue?: number;
        FranchiseeDiscountAmount?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: boolean;
        ConvertToOrder?: boolean;
        NetAmountAfterFrDiscount?: number;
        CartProducts?: CartProductsRow[];
        TaxAmount?: number;
    }

    export namespace CounterCartRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Carts.CounterCart';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            FranchiseeId = "FranchiseeId",
            CustomerId = "CustomerId",
            CustomerName = "CustomerName",
            CustomerEmail1 = "CustomerEmail1",
            CustomerEmail2 = "CustomerEmail2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            BillingAddress1 = "BillingAddress1",
            BillingAddress2 = "BillingAddress2",
            BillingCity = "BillingCity",
            BillingStateId = "BillingStateId",
            BillingPincode = "BillingPincode",
            ShippingAddress1 = "ShippingAddress1",
            ShippingAddress2 = "ShippingAddress2",
            ShippingCity = "ShippingCity",
            ShippingStateId = "ShippingStateId",
            ShippingPincode = "ShippingPincode",
            EInvoiceTo = "EInvoiceTo",
            EPaymentStatus = "EPaymentStatus",
            EPaymentType = "EPaymentType",
            InvoiceCompanyId = "InvoiceCompanyId",
            DiscountCoupon = "DiscountCoupon",
            DiscountAmount = "DiscountAmount",
            SourceOrderNumber = "SourceOrderNumber",
            GrossAmount = "GrossAmount",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            EFranchiseeDiscountType = "EFranchiseeDiscountType",
            EFranchiseeDiscount = "EFranchiseeDiscount",
            FranchiseeDiscountValue = "FranchiseeDiscountValue",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            ConvertToOrder = "ConvertToOrder",
            NetAmountAfterFrDiscount = "NetAmountAfterFrDiscount",
            CartProducts = "CartProducts",
            TaxAmount = "TaxAmount"
        }
    }
}
